import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../lib/axios';
import type { SubscriptionMetrics } from '../../types/subscriptions';

const QUERY_KEYS = {
  stats: ['subscription-stats'] as const,
};

export const useSubscriptionStats = () => {
  return useQuery({
    queryKey: QUERY_KEYS.stats,
    queryFn: async () => {
      // Note: This endpoint might need to be created in the backend
      // For now, we'll structure it to expect this data
      const { data } = await axiosInstance.get<SubscriptionMetrics>('/subscriptions/stats');
      return data;
    },
  });
};
